/**
 * Toon alle def_locations met de optie om eentje te selecteren, aanroepende component geeft een current_id door en een callback voor sluiten als waarde > 0 is er iets geselecteerd
 *
 *
 *
 * @history
 * 16 januari 2023
 * Basis implementatie
 *
 */

import React from "react";

import {Popup} from "../containers/Popup";






export class LocationLibSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                init_done: false,
                def_locations:[]


            };



    }

    componentDidMount() {
        const formData = new FormData();
        formData.append("access_id1", window.app.logboek.access_id1);
        formData.append("access_id2", window.app.logboek.access_id2);


        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch("/get_def_locations", requestOptions)
            .then(response => response.json())
            .then(def_locations_json => {
                if (def_locations_json.status == "ok") {
                    this.setState({"init_done": true,"def_locations":def_locations_json.data});

                } else {
                    console.log("?");
                }
            });
    }




    render() {

        return (
            <Popup  has_close_btn={true} title={"Kies een afbeelding uit de bibliotheek"} callback={() => this.props.callback(0,"")}>

                {!this.state.init_done &&
                    (
                        <p>Bezig met laden ....</p>

                    )}

                {this.state.init_done  && this.state.def_locations.map((def_location, def_location_index) =>
                    (
                        <>
                            <a href="javascript:void(0);" onClick={() => this.props.callback(def_location.id, def_location.image_url)}><div className="location_select_location_wrapper">
                                <div className="location_select_location_img" style={{"background-image": "url('" + def_location.image_url + "'",
                                    "background-size": "contain"}}>
                                    {this.props.current_id == def_location.id &&
                                        (
                                    <img src="/digibord/assets/svgs/checked_red.svg" style={{"width":"25%"}}/>
                                        )}
                                </div>
                                <div className="location_select_location_title">{def_location.title}</div>
                            </div>
                            </a>
                        </>
                    )
                )}




            </Popup>
        );
    }

}
